import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default function Modal({ title, onClose, children, width = 560 }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        background: "rgba(5,5,8,0.85)",
        backdropFilter: "blur(4px)",
        overflowY: "auto",
        padding: "16px",
        paddingTop: 72,
      }}
    >
      <div
        style={{
          width: "100%", maxWidth: width,
          margin: "0 auto",
          background: "var(--color-surface)",
          border: "1px solid rgba(68,136,255,0.5)",
          borderRadius: 10,
          boxShadow: "0 0 0 1px rgba(68,136,255,0.12), 0 0 32px rgba(68,136,255,0.12), 0 0 80px rgba(0,0,0,0.7)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "16px 20px",
            borderBottom: "1px solid var(--color-border)",
          }}
        >
          <h2 className="data text-sm font-semibold" style={{ color: "var(--color-white)", letterSpacing: "0.05em" }}>
            {title}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none", border: "none", cursor: "pointer",
              color: "var(--color-muted)", fontSize: 16, padding: 4,
              lineHeight: 1,
            }}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "20px" }}>
          {children}
        </div>
      </div>
    </div>
  );
}
